<template>
    <div v-if="estate.estate_parent || estate.estates_child || estate.estates_sibling" class="estate-container">
        <div class="estate-family-title">
            <masked-image class="icon_title" src="/img/icons/industrial.svg"></masked-image>
            <h2>
                <div v-if="estate.estate_parent">
                    {{ lang.related.estate_parent }}
                </div>
                <div v-else-if="estate.estates_child || estate.estates_sibling">
                    {{ lang.related.estates_child }}
                </div>
            </h2>
        </div>
        <div class="estate-family">
            <template v-if="estate.estate_parent || estate.estate_parent || estate.estates_child">
                <my-carousel
                    :per-page-custom="[[0, 1], [768, 2], [940, 3]]"
                    :scroll-per-page="true"
                    :navigation-enabled="true"
                    navigation-next-label="<span></span>"
                    navigation-prev-label="<span></span>"
                    :pagination-enabled="true"
                >
                    <slide v-if="estate.estate_parent">
                        <related-estate
                            :related_estate="estate.estate_parent"
                            type="parent"
                        ></related-estate>
                    </slide>

                    <slide
                        v-if="estate.estates_sibling"
                        v-for="estate_sibling, num_sibling in estate.estates_sibling"
                        :key="num_sibling"
                    >
                        <related-estate
                            :related_estate="estate_sibling"
                            type="sibling"
                        />
                    </slide>

                    <slide
                        v-if="estate.estates_child"
                        v-for="estate_child, num_child in estate.estates_child"
                        :key="num_child"
                    >
                        <related-estate
                            :related_estate="estate_child"
                            type="child"
                        />
                    </slide>
                </my-carousel>
            </template>
        </div>
    </div>
</template>

<script>
import RelatedEstate from './RelatedEstate'
import MyCarousel from '../MyCarousel'
export default {
    components: {
        'related-estate': RelatedEstate,
        MyCarousel
    },

    props: {
        estate: {
            type: Object,
            required: true,
        },
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },
}
</script>